<div style="padding: 20px; ">
  <h4>Upload documents for {{data.unitNumber}}</h4>
  <div style="display: flex; justify-content: space-between; align-items: center; border: 1px solid #ebebeb; padding: 20px 40px; border-radius: 6px">
    <input #documentsInput type="file" style="outline: none" multiple="" (change)="onFileChangeForDocuments($event)">
    <button mat-button (click)="uploadDocuments()" style="color: white; background: #3C50E0">Upload</button>
  </div>

  <ng-container *ngIf="data.documents && data.documents.length > 0">
    <h4>Manage documents for {{data.unitNumber}}</h4>
    <div fxLayout="row" fxLayoutGap="30px" style="overflow: scroll; margin-top: 20px">
      <div *ngFor="let file of data.documents" style="border-radius: 8px; border:solid 1px #f5f7fa; width: 180px; height: 200px; display: flex; flex-direction: column;">
        <div
          style="border-top-right-radius: 8px; border-top-left-radius: 8px; width: 180px; height: 100px; background: #e3ebf7; display: flex; justify-content: center; align-items: center">
          <img src="./assets/images/{{file.fileType}}" style="height: 95px; width: 73px">
        </div>
        <div style="flex-grow: 1;  padding: 10px; display: flex; flex-direction: column; justify-content: space-between">
          <div style="font-size: 14px; word-break: break-all">{{file.fileName.slice(file.fileName.indexOf('_') + 1)}}</div>
          <div style="display: flex; justify-content: space-between; align-items: center">
            <img src="./assets/images/delete.svg" (click)="deleteDocument(file.id)" style="width: 20px; height: 20px; cursor: pointer">
            <img src="./assets/images/downloadicon.svg" (click)="openTerms(file.fileName)" style="width: 20px; height: 20px; cursor: pointer">
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <div style="display: flex; justify-content: flex-end; margin-top: 20px">
    <button mat-button style="background: #3C50E0; color: white" (click)="cancel()">Close</button>
  </div>
</div>